import axios from 'axios';
import store from '@/store/index';
import { Toast } from 'vant';
import { convertLongInt, getUrlParamsObj } from '@/scripts/utils';
import { setUserAuth } from '@/scripts/userAuth';

global.APP_CONFIG = global.APP_CONFIG || {};
const toast = null;

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_PATH || '',
  timeout: 20000,
  responseType: 'text',
  transformResponse: [
    (data) => {
      return data;
    },
  ],
});

const login = () => {
  setUserAuth({
    authType: global.APP_CONFIG.auth_type,
    authFn: () => {},
  });
};
let defaultToken = '';
if (process.env.NODE_ENV === 'development') {
  defaultToken = 'bdc62235-789f-4db2-ae70-cfb3de14db60';
}
service.interceptors.request.use(
  (config) => {
    const userInfo = store.getters['userAuth/getUsersCurrentInfo'];
    if (userInfo) {
      config.headers['departmentIds'] = Array.isArray(userInfo.orgId)
        ? userInfo.orgId
        : [userInfo.orgId];
      config.headers['roleids'] = userInfo.roles;
      config.headers['roleType'] = userInfo.roleType;
      config.headers['centerUserId'] = userInfo.name;
    }

    config.headers['tenantId'] = global.APP_CONFIG.tenantId;
    config.headers['x-token'] = store.getters['userAuth/getAuthorizeInfo']
      ? store.getters['userAuth/getAuthorizeInfo'].token
      : defaultToken;
    // Bcenter鉴权
    config.headers['userId'] = userInfo ? userInfo.name : '';
    config.headers['empId'] = userInfo ? userInfo.name : '';
    config.headers['name'] = userInfo ? encodeURI(userInfo.userName) : '';
    config.headers['orgId'] = userInfo ? userInfo.orgId : '';
    if (process.env.VUE_APP_PROJ === 'audi') {
      config.headers['orgList'] = userInfo ? userInfo.org : '';
      config.headers['roles'] = userInfo ? userInfo.roles : '';
      // Bcenter鉴权,如果是iframe嵌套则写死默认userId
      const userId =
        self !== top || getUrlParamsObj().notInQw
          ? process.env.VUE_APP_ENV !== 'prod'
            ? process.env.VUE_APP_ENV === 'test'
              ? '13265894707'
              : '1427935316787109888'
            : '1452633981417988096'
          : userInfo
          ? userInfo.name
          : '';
      config.headers['userId'] = userId;
    } else {
      config.headers['queryActionFlag'] = true;
      const userId =
        self !== top || getUrlParamsObj().notInQw
          ? process.env.VUE_APP_ENV !== 'prod'
            ? process.env.VUE_APP_ENV === 'test'
              ? '144115205301725086'
              : '144115205301725086'
            : '144115205301725086'
          : userInfo
          ? userInfo.name
          : '';
      config.headers['userId'] = userId;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    if (toast) {
      toast.clear();
    }
    const res = JSON.parse(convertLongInt(response.data)); // Long型数值转化
    // 部分接口免鉴权
    if (
      res.code === 50002 &&
      !['/dapi/auth/v1/app/authorize'].includes(response.config.url)
    ) {
      // 令牌不存在或已失效
      return login();
    } else {
      if (
        ((res.code && res.code !== 0) || (res.status && res.status !== 200)) &&
        !response.config.headers['noErrToast']
      ) {
        Toast.fail({
          message: res.msg || res.message,
          duration: 3 * 1000,
        });
      }
    }
    return res;
  },
  (error) => {
    console.log('error', error);
    const res = JSON.parse(convertLongInt(error.response.data));
    if (res.code === 50002) {
      // 令牌不存在或已失效
      login();
    }
    if (toast) {
      toast.clear();
    }
    return Promise.reject(error);
  }
);

export function post(url, params, hasFailTip = true) {
  return service.post(url, params).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err, 'post内部err');
      const errObj = JSON.parse(err.response.data);
      if (errObj.status !== 200) {
        Toast.fail({
          message: errObj.message,
          duration: 3 * 1000,
        });
      }
      return Promise.reject(err);
    }
  );
}

export function get(url, params, hasFailTip = true) {
  return service({
    method: 'get',
    url: url,
    params,
  }).then(
    (res) => {
      return res;
    },
    (err) => {
      return Promise.reject(err);
    }
  );
}

export function del(url, params, hasFailTip = true) {
  return service({
    method: 'delete',
    url: url,
    params,
  }).then(
    (res) => {
      return res;
    },
    (err) => {
      return Promise.reject(err);
    }
  );
}

// 提供给上传使用
export function upload(url, params) {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } };
  return service.post(url, params, config).then(
    (res) => {
      return res;
    },
    (err) => {
      return Promise.reject(err);
    }
  );
}

export default service;
